export default __webpack_public_path__ + "/dist/images/food-list-icon.11d93427ee9d4599a21b7f7c92917e1a.svg";